module.exports={render:function (){
var _obj, _obj$1;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-imbee-wrapper",
    style: (( _obj = {
      maxWidth: _vm.chat.width,
      maxHeight: _vm.chat.height,
      bottom: 0
    }, _obj[_vm.alignment] = 0, _obj )),
    attrs: {
      "data-open": _vm.showWrapper,
      "data-fullscreen": _vm.fullScreen
    }
  }, [_c('transition', {
    attrs: {
      "name": "imbee-fadeIn",
      "enter-active-class": "imbee-fadeInUp",
      "leave-active-class": "imbee-fadeOutDown"
    },
    on: {
      "before-enter": function () {
        _vm.showWrapper = true;
      },
      "after-leave": function () {
        _vm.showWrapper = false;
      }
    }
  }, [_c('Container', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fullScreen ? true : _vm.chat.show),
      expression: "fullScreen ? true : chat.show"
    }],
    staticClass: "w-imbee-container",
    style: (( _obj$1 = {
      maxWidth: _vm.chat.width,
      maxHeight: _vm.chat.height,
      bottom: _vm.chat.verticalPadding
    }, _obj$1[_vm.alignment] = _vm.chat.horizontalPadding, _obj$1 )),
    attrs: {
      "full-screen": _vm.fullScreen,
      "data-fullscreen": _vm.fullScreen,
      "header": _vm.header,
      "loader": _vm.loader,
      "cookieBanner": _vm.cookieBanner,
      "footer": _vm.footer,
      "humanizacion": _vm.humanizacion,
      "chat": _vm.chat
    },
    on: {
      "close": function($event) {
        return _vm.close()
      }
    }
  })], 1), _vm._v(" "), (!_vm.fullScreen) ? _c('CallToAction', {
    attrs: {
      "show": _vm.callToAction.show && _vm.callToAction.showCta && _vm.bubble.show && !_vm.chat.show,
      "opened": _vm.chat.show,
      "alignment": _vm.alignment,
      "call-to-action": _vm.callToAction
    },
    on: {
      "open": function($event) {
        return _vm.open()
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.fullScreen) ? _c('Bubble', {
    attrs: {
      "opened": _vm.chat.show,
      "alignment": _vm.alignment,
      "bubble": _vm.bubble,
      "badge": _vm.badge,
      "textBadge": _vm.textBadge,
      "closeCross": _vm.closeCross,
      "show-cta": _vm.callToAction.showCta
    },
    on: {
      "clicked": function($event) {
        return _vm.toggleChat()
      },
      "crossclicked": _vm.handleCrossClicked
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-63f4bbe7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Wrapper.vue
// module id = 215
// module chunks = 0 1